import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import bhajanReducer from '../Features/BhajanSlice';
import languageReducer from "../Features/LanguageSlice";
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    bhajans: bhajanReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware as any),
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
